import React, { FC } from 'react';
import {
  PageContent,
  PageSection,
  PageTitle,
  PrivacyIButton,
} from './privacy.styles';

type Props = {
  data: Record<string, never>;
};
export const Privacy = (props: Props) => {
  return (
    <PageSection position="topRight">
      <PageContent>
        <PageTitle variant="h1">
          {props.data.title ?? 'Home Stepper - Privacy Policy'}
        </PageTitle>
        <div
          dangerouslySetInnerHTML={{ __html: props.data.content ?? '' }}
        ></div>
        <a href={props.data.file} target="_blank">
          <PrivacyIButton>Privacy Policy</PrivacyIButton>
        </a>
      </PageContent>
    </PageSection>
  );
};
